import React from "react";

import { StyledSVG } from "../StyledIcon";

export const FavIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M16.4324 7.3126C15.9014 10.8351 9.01642 15.7501 9.01642 15.7501C6.71161 14.6249 1.99584 10.4622 1.57124 7.3126C1.0405 3.37558 3.00098 2.25098 4.7557 2.25098C6.37598 2.25098 7.40793 3.12995 9.00091 4.94026C10.3085 3.1368 11.6513 2.25093 13.2469 2.25098C14.8417 2.25102 16.9634 3.79006 16.4324 7.3126Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
